export default __webpack_public_path__ + "static/media/did-you-know-no-result.33a1680e.svg";